import { ReactSVG } from "react-svg";
import { LuX } from "react-icons/lu";
import NavBar from "../NavBar/NavBar.jsx";
import LogoutBtn from "../LogoutBtn/LogoutBtn.jsx";
import { useMenu } from "../../context/MenuContext.js";
import { UseMediaQuery } from "../../hooks/UseMediaQuery.js";
import logo from "../../assets/icons/logo1.svg";
import avatar from "../../assets/images/avatar1.png";
import * as styled from "./LeftPanel.styled.jsx";

// Бічна панель кабінету. На телефоні — меню, що виїжджає зліва поверх сторінки.
function LeftPanel({ navList, pageTitle, currentRoute, notAdmin, userName }) {
  const { showMenu, setShowMenu } = useMenu();
  const { isMobile } = UseMediaQuery();
  const close = () => setShowMenu(false);

  return (
    <>
      {isMobile && <styled.Backdrop $open={showMenu} onClick={close} />}
      <styled.Panel $open={showMenu}>
        <styled.Header>
          <ReactSVG src={logo} className="left-panel-logo" />
          {isMobile && (
            <styled.CloseButton onClick={close} aria-label="Закрити меню">
              <LuX size={20} />
            </styled.CloseButton>
          )}
        </styled.Header>

        {notAdmin && userName ? (
          <styled.Profile>
            <styled.Avatar src={avatar} alt="" />
            <styled.ProfileText>
              <styled.Hello>Привіт,</styled.Hello>
              <styled.Name>{userName}</styled.Name>
              <styled.Role>{pageTitle}</styled.Role>
            </styled.ProfileText>
          </styled.Profile>
        ) : (
          <styled.RoleBadge>{pageTitle}</styled.RoleBadge>
        )}

        <NavBar navList={navList} currentRoute={currentRoute} setShowMenu={setShowMenu} />

        <styled.Footer>
          <LogoutBtn />
        </styled.Footer>
      </styled.Panel>
    </>
  );
}

export default LeftPanel;
